// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import YahooOutlinedSvg from "@fishx/icons-svg/es/asn/YahooOutlined";
import FishxIcon from '../components/FishxIcon';

var YahooOutlined = function YahooOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: YahooOutlinedSvg
  }));
};

YahooOutlined.displayName = 'YahooOutlined';
export default React.forwardRef(YahooOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/YahooOutlined.js
// module id = 4413
// module chunks = 0